import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import image from '../img/erziehungsziele-geburtstag.jpg';
import TextAndImagePage from '../components/TextAndImagePage';
import Text, { Paragraphs } from '../components/Text';

const RoomDesignPage: React.FC<{ data: any }> = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout>
      <TextAndImagePage
        title={post.frontmatter.title}
        content={<Paragraphs>{post.frontmatter.text}</Paragraphs>}
        image={image}
        backLink="/konzept"
      />
    </Layout>
  );
};

export default RoomDesignPage;

export const query = graphql`
  query RoomDesignPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        text
      }
    }
  }
`;
